// Required for dev hot reload
if (import.meta.hot) {

    import.meta.hot.accept(() => {
      console.log("HMR")
    });
}

import ServiceAgents from './components/support/sales-support';
document.addEventListener('DOMContentLoaded', ServiceAgents, false);